import { configureStore, Reducer, UnknownAction } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { persistStore, persistReducer } from 'redux-persist';
import { rootSaga } from './rootSaga';
import rootReducer from './rootReducer';
import { persistConfig } from './persistConfig';

// ==============================================================
type TRootState = ReturnType<typeof rootReducer>;

// redux-persist types predate Redux 5 (`Reducer` has a 3rd `PreloadedState` generic),
// so the base reducer is narrowed to the 2-generic form that `persistReducer` expects.
const persistedReducer = persistReducer<TRootState, UnknownAction>(
	persistConfig,
	rootReducer as Reducer<TRootState, UnknownAction>,
);

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
	reducer: persistedReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: false,
		}).concat(sagaMiddleware),
	devTools: true,
});

const persistor = persistStore(store);

sagaMiddleware.run(rootSaga);

export { store, persistor };
